window.PSN = window.PSN || {};
PSN.EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

function psnInitReveal(root) {
  const els = (root || document).querySelectorAll('[data-psn-reveal]:not(.is-in)');
  if (!('IntersectionObserver' in window)) return els.forEach((el) => el.classList.add('is-in'));
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach((el) => io.observe(el));
}

function psnInitHeader() {
  const header = document.querySelector('[data-psn-header]');
  if (!header) return;

  const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const closeAll = (except) => {
    header.querySelectorAll('[data-psn-menu][aria-expanded="true"]').forEach((btn) => {
      if (btn !== except) psnSetMenu(btn, false);
    });
  };

  header.querySelectorAll('[data-psn-menu]').forEach((btn) => {
    const item = btn.closest('[data-psn-menu-item]');
    let timer;
    const open = () => { clearTimeout(timer); closeAll(btn); psnSetMenu(btn, true); };
    const close = () => { timer = setTimeout(() => psnSetMenu(btn, false), 150); };
    if (btn.dataset.psnMenu === 'hover') {
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
    }
    btn.addEventListener('click', (e) => {
      if (btn.tagName === 'A' && btn.dataset.psnMenu === 'hover' && btn.getAttribute('aria-expanded') === 'true') return;
      e.preventDefault();
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      closeAll(btn);
      psnSetMenu(btn, !isOpen);
      // The phone menu sits later in the page than the header icons, so jump focus into it when it opens.
      if (!isOpen && btn.classList.contains('psn-header__burger')) {
        document.getElementById(btn.getAttribute('aria-controls'))?.querySelector('a, button, input, [tabindex]:not([tabindex="-1"])')?.focus();
      }
    });
  });

  document.addEventListener('click', (e) => { if (!header.contains(e.target)) closeAll(); });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = header.querySelector('[data-psn-menu][aria-expanded="true"]');
    if (open) { psnSetMenu(open, false); open.focus(); }
  });
}

function psnSetMenu(btn, open) {
  btn.setAttribute('aria-expanded', open);
  const panel = document.getElementById(btn.getAttribute('aria-controls'));
  if (panel) panel.hidden = !open;
}

function psnInitEmailForms() {
  document.querySelectorAll('form[data-psn-email-form]').forEach((form) => {
    form.setAttribute('novalidate', '');
    form.addEventListener('submit', (e) => {
      const input = form.querySelector('input[type="email"]');
      const error = form.querySelector('[data-psn-email-error]');
      const ok = PSN.EMAIL_RE.test(input.value.trim());
      input.setAttribute('aria-invalid', !ok);
      if (error) error.hidden = ok;
      if (!ok) { e.preventDefault(); input.focus(); }
    });
  });
}

PSN.initReveal = psnInitReveal;
document.addEventListener('DOMContentLoaded', () => {
  psnInitReveal();
  psnInitHeader();
  psnInitEmailForms();
});
document.addEventListener('shopify:section:load', (e) => psnInitReveal(e.target));

// Shopify marks every customer form as posted after any customer-form submit; only the one whose id is in the hash really was.
document.addEventListener('DOMContentLoaded', () => {
  if (new URLSearchParams(location.search).get('customer_posted') !== 'true') return;
  document.querySelectorAll('form[data-psn-email-form]').forEach((form) => {
    if (location.hash === '#' + form.id) return;
    form.querySelector('[data-psn-form-success]')?.remove();
    const fields = form.querySelector('[data-psn-form-fields]');
    if (fields) fields.hidden = false;
  });
});
